import React, { useContext } from "react";
import "./sidebardata.css";
import { StoreContext } from "../../../../../Store/Provider";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Milestone from "./Milestone";
import MapComponent from "./MapComponent";
import DocumentComponent from "./DocumentComponent";
import ShipmentDataDetails from "./ShipmentDataDetails";
import DocumentSVG from "../../../../SVG/DocumentSVG";
import LocateTrack from "../../../../SVG/LocateTrack";
import ShipmentDetailsIcon from "../../../../SVG/ShipmentDetailsIcon";
import MileStone from "../../../../SVG/MileStone";
import containerDetails from "./ContainerDetails";

function SidebarData(props) {
  const context = useContext(StoreContext);
  const { detail, milestone } = props;

  return (
    <div className="sidebarData">
      <div className="sidebarDataHeading">
        <h5
          onClick={() => {
            context.setSidebarContent("shipmentDetails");
          }}
        >
          <ArrowBackIosIcon /> {""}
          {context.shipmentNo}
        </h5>
        <div className="">
          <div className="shipmentDetailsTabDivIconTitle">
            {context.sidebarContent === "milestones" ? (
              <>
                <div>
                  <MileStone
                    colorCode={"rgba(var(--text-heading-light))"}
                    onClickLocate={() => {}}
                    classSidebar={"classSidebar"}
                  />
                </div>
                <span>Milestones</span>
              </>
            ) : context.sidebarContent === "track" ? (
              <>
                <div>
                  <LocateTrack
                    colorCode={"rgba(var(--text-heading-light))"}
                    onClickLocate={() => {}}
                    classSidebar={"classSidebar"}
                  />
                </div>
                <span>Track on Map</span>
              </>
            ) : context.sidebarContent === "shipmentDataDetails" ? (
              <>
                <div>
                  <ShipmentDetailsIcon
                    colorCode={"rgba(var(--text-heading-light))"}
                    classSidebar={"classSidebar"}
                  />
                </div>
                <span>Details of Shipments</span>
              </>
            ) : context.sidebarContent === "Documents" ? (
              <>
                <div>
                  <DocumentSVG
                    colorCode={"rgba(var(--text-heading-light))"}
                    classSidebar={"classSidebar"}
                  />
                </div>
                <span>Documents</span>
              </>
            ) : (
              // : context.sidebarContent === "ContainerData" ? (
              //   <>
              //     <div>
              //       <DocumentSVG
              //         colorCode={"rgba(var(--text-heading-light))"}
              //         classSidebar={"classSidebar"}
              //       />
              //     </div>
              //     <span>Container Details</span>
              //   </>
              // )
              "Invalid Component"
            )}
          </div>
        </div>
      </div>
      {context.sidebarContent === "milestones" ? (
        <Milestone milestone={milestone} />
      ) : context.sidebarContent === "track" ? (
        <MapComponent />
      ) : context.sidebarContent === "shipmentDataDetails" ? (
        <ShipmentDataDetails detail={detail} />
      ) : context.sidebarContent === "Documents" ? (
        <DocumentComponent />
      ) : (
        "Invalid Component"
      )}
    </div>
  );
}

export default SidebarData;
